


























import { API, compass } from '@resclick/compass';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class QSelectDynamic<N extends keyof API, A extends keyof API[N]> extends Vue {
  @Prop() namespace!: N;
  @Prop() action!: A;
  @Prop() handler!: (query: any) => ReturnType<typeof compass.do>;
  @Prop({ required: true }) optionValue!: string;
  @Prop({ required: true }) optionLabel!: string;
  @Prop({ default: () => ({}) }) query!:
    | {
        filter: Record<string, unknown>;
        params: Record<string, unknown>;
        select: any;
      }
    | false;
  @Prop() value!: any;
  @Prop() displayValue!: any;
  @Prop() multiple!: any;
  @Prop() error!: any;
  @Prop() errorMessage!: any;
  @Prop() clearable!: any;

  model = '';
  totalCount = 0;
  loading = false;
  optionsStorage: any = [];
  options: any = [];
  filterOptions: any = [];

  get displayValueSmart() {
    if (this.loading) {
      return 'LOADING';
    }
    return this.displayValue;
  }

  get valueSync() {
    return this.value;
  }

  set valueSync(val: any) {
    this.$emit('input', val);
  }

  get _options() {
    return Object.freeze(this.options);
  }

  get _filterOptions() {
    return Object.freeze(this.filterOptions);
  }

  get request() {
    if (this.handler) return this.handler;
    return (config: any) => compass.do(this.namespace, this.action, config);
  }

  @Watch('$i18n.locale')
  onLocaleChange() {
    this.initialize();
  }

  filterFn(val: any, update: any) {
    if (val === '') {
      update(() => (this.options = this.optionsStorage));
      return;
    }

    update(() => {
      const needle = val.toLowerCase();
      this.options = this.optionsStorage.filter((v: any) => {
        const comp = this.optionLabel && v[this.optionLabel] ? v[this.optionLabel] : v;
        return comp.toLowerCase().indexOf(needle) > -1;
      });
    });
  }

  public initialize() {
    if (this.query !== false) {
      const { filter = {}, params = {}, select = [] } = JSON.parse(JSON.stringify(this.query));
      this.loading = true;
      const _options: any[] = [];
      this.request({
        filter,
        params: { ...params },
        select: [this.optionValue, this.optionLabel, ...select],
        page: 1,
        limit: 100,
      })
        .then(async ({ data, headers }: any) => {
          this.totalCount = Number(headers['x-pagination-total-count']) || 0;
          _options.push(...data);

          let pageIndex = 1;
          const postRequests: any = [];
          while (this.totalCount > pageIndex * 100) {
            postRequests.push(
              compass.do(this.namespace as any, this.action, {
                filter,
                params: { ...params },
                select: [this.optionValue, this.optionLabel, ...select],
                page: ++pageIndex,
                limit: 100,
              }),
            );
          }
          const res = await Promise.all(postRequests);
          this.optionsStorage = [..._options, ...res.flatMap((r: any) => r.data)];
          this.options = Object.freeze(this.optionsStorage);
        })
        .finally(() => (this.loading = false));
    }
  }

  showPopup() {
    return (this.$refs.original as any).showPopup();
  }

  created() {
    this.initialize();
  }
}
